module.exports = "https://cdn.thelire.com/ins/resource/limit_title.7ace851e414e31523bffbe3b7e9ee6b6.png";